import Leaflet from './Leaflet';

class BufferAreaLayer {
    constructor (currentMap) {
        return new Leaflet.GeoJSONLayer({
            map: currentMap,
            cache: true,
            showAll: true,
            autofocus: false,
            uniqueField: 'IdLoja',
            below: true,
            incremental: true,
            symbology: {
                type: 'single',
                style: {
                    fillColor: '#FFB74D',
                    fillOpacity: 0.5,
                    color: '#FFA726',
                    opacity: 0.8,
                    weight: 1,
                    clickable: false
                }
            }
        });
    }
}

export default BufferAreaLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/BufferAreaLayer.js